import { FIELDS, PUMP_RATES_SUMMARY } from "../configurations/Urls";
import Session from "../helpers/SessionHelper";
import axios from "axios";

const WellSummaryService = {
  async getWellSummary(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(`${FIELDS}/well/summary`, payload, {
      headers: headers,
    });
    return response;
  },
  async getPumpRateReport(payload, signal) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(payload, { headers, signal });
    return response;
  },
  async exportPumpRateReport(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    headers.Accept = "application/vnd.ms-excel";
    const response = await axios.get(payload, {
      headers: headers,
      responseType: "blob",
      redirect: "follow",
    });
    return response;
  },
};

export default WellSummaryService;
